
	import Fight from '@/component/fight/fight.vue'
	import { loadInstanceTranslations, i18n } from '@/model/i18n'
	const messages = {
	"battle_royale": "Battle royale",
	"date_format": "{0}",
	"deleted_farmer": "farmer deleted",
	"deleted_leek": "leek deleted",
	"deleted_team": "team deleted",
	"n_views": "no view | 1 view | {n} views",
	"not_found": "Fight not found :(",
	"not_found_id": "Fight with id <b>{0}</b> not found :(",
	"pause_message": "Click or press 'P' to resume",
	"starter": "Fight launcher"
}

	Fight.options.i18n = { messages: {en: messages }}
	export default Fight